import formSections from './formSections/index';

export const SF852013 = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_PHYSICAL,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_MULTIPLE,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_REVIEW,
    ],
  },
  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_SELECTIVE,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.RELATIONSHIPS,
    subsections: [
      formSections.RELATIONSHIPS_INTRO,
      formSections.RELATIONSHIPS_PEOPLE,
      formSections.RELATIONSHIPS_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [formSections.SUBSTANCE_USE_DRUGS_USAGE],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
];

export const SF85 = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_PHYSICAL,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },
  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_MULTIPLE,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_SELECTIVE,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_DISCIPLINARY,
      formSections.MILITARY_FOREIGN,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.FINANCIAL,
    subsections: [
      formSections.FINANCIAL_INTRO,
      formSections.FINANCIAL_TAXES,
      formSections.FINANCIAL_DELINQUENT,
      formSections.FINANCIAL_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [
          formSections.SUBSTANCE_USE_DRUGS_USAGE,
          formSections.SUBSTANCE_USE_DRUGS_PURCHASE,
          formSections.SUBSTANCE_USE_DRUGS_MISUSE,
          formSections.SUBSTANCE_USE_DRUGS_ORDERED,
          formSections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
        ],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
  {
    ...formSections.LEGAL,
    subsections: [
      formSections.LEGAL_INTRO,
      {
        ...formSections.LEGAL_POLICE,
        subsections: [
          formSections.LEGAL_POLICE_INTRO,
          formSections.LEGAL_POLICE_OFFENSES,
          formSections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
        ],
      },
      {
        ...formSections.LEGAL_INVESTIGATIONS,
        subsections: [
          formSections.LEGAL_INVESTIGATIONS_HISTORY,
          formSections.LEGAL_INVESTIGATIONS_REVOKED,
          formSections.LEGAL_INVESTIGATIONS_DEBARRED,
        ],
      },
      {
        ...formSections.LEGAL_ASSOCIATIONS,
        subsections: [
          formSections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION,
          formSections.LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM,
          formSections.LEGAL_ASSOCIATIONS_ADVOCATING,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE,
          formSections.LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION,
        ],
      },
      formSections.LEGAL_REVIEW,
    ],
  },
];

export const SF85P = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_PHYSICAL,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },

  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_FEDERAL,
      formSections.HISTORY_REVIEW,
    ],
  },
  {
    ...formSections.RELATIONSHIPS,
    subsections: [
      formSections.RELATIONSHIPS_INTRO,
      {
        ...formSections.RELATIONSHIPS_STATUS,
        subsections: [
          formSections.RELATIONSHIPS_STATUS_MARITAL,
          formSections.RELATIONSHIPS_STATUS_COHABITANTS,
        ],
      },
      formSections.RELATIONSHIPS_PEOPLE,
      formSections.RELATIONSHIPS_RELATIVES,
      formSections.RELATIONSHIPS_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_MULTIPLE,
      formSections.CITIZENSHIP_PASSPORTS,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_SELECTIVE,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_DISCIPLINARY,
      formSections.MILITARY_FOREIGN,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.FOREIGN,
    subsections: [
      formSections.FOREIGN_INTRO,
      formSections.FOREIGN_TRAVEL,
      formSections.FOREIGN_REVIEW,
    ],
  },
  {
    ...formSections.FINANCIAL,
    subsections: [
      formSections.FINANCIAL_INTRO,
      formSections.FINANCIAL_BANKRUPTCY,
      formSections.FINANCIAL_GAMBLING,
      formSections.FINANCIAL_TAXES,
      formSections.FINANCIAL_CARD,
      formSections.FINANCIAL_CREDIT,
      formSections.FINANCIAL_DELINQUENT,
      formSections.FINANCIAL_NONPAYMENT,
      formSections.FINANCIAL_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [
          formSections.SUBSTANCE_USE_DRUGS_USAGE,
          formSections.SUBSTANCE_USE_DRUGS_PURCHASE,
          formSections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
          formSections.SUBSTANCE_USE_DRUGS_MISUSE,
          formSections.SUBSTANCE_USE_DRUGS_ORDERED,
          formSections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_ALCOHOL,
        subsections: [
          formSections.SUBSTANCE_USE_ALCOHOL_NEGATIVE,
          formSections.SUBSTANCE_USE_ALCOHOL_ORDERED,
          formSections.SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
        ],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
  {
    ...formSections.LEGAL,
    subsections: [
      formSections.LEGAL_INTRO,
      {
        ...formSections.LEGAL_POLICE,
        subsections: [
          formSections.LEGAL_POLICE_INTRO,
          formSections.LEGAL_POLICE_OFFENSES,
          formSections.LEGAL_POLICE_ADDITIONAL_OFFENSES,
          formSections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
        ],
      },
      {
        ...formSections.LEGAL_INVESTIGATIONS,
        subsections: [
          formSections.LEGAL_INVESTIGATIONS_HISTORY,
          formSections.LEGAL_INVESTIGATIONS_REVOKED,
          formSections.LEGAL_INVESTIGATIONS_DEBARRED,
        ],
      },
      formSections.LEGAL_COURT,
      {
        ...formSections.LEGAL_TECHNOLOGY,
        subsections: [
          formSections.LEGAL_TECHNOLOGY_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_MANIPULATING,
          formSections.LEGAL_TECHNOLOGY_UNLAWFUL,
        ],
      },
      {
        ...formSections.LEGAL_ASSOCIATIONS,
        subsections: [
          formSections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION,
          formSections.LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM,
          formSections.LEGAL_ASSOCIATIONS_ADVOCATING,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE,
          formSections.LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION,
        ],
      },
      formSections.LEGAL_REVIEW,
    ],
  },
];

export const SF85PS = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_PHYSICAL,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },

  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_FEDERAL,
      formSections.HISTORY_REVIEW,
    ],
  },
  {
    ...formSections.RELATIONSHIPS,
    subsections: [
      formSections.RELATIONSHIPS_INTRO,
      {
        ...formSections.RELATIONSHIPS_STATUS,
        subsections: [
          formSections.RELATIONSHIPS_STATUS_MARITAL,
          formSections.RELATIONSHIPS_STATUS_COHABITANTS,
        ],
      },
      formSections.RELATIONSHIPS_PEOPLE,
      formSections.RELATIONSHIPS_RELATIVES,
      formSections.RELATIONSHIPS_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_MULTIPLE,
      formSections.CITIZENSHIP_PASSPORTS,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_SELECTIVE,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_DISCIPLINARY,
      formSections.MILITARY_FOREIGN,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.FOREIGN,
    subsections: [
      formSections.FOREIGN_INTRO,
      formSections.FOREIGN_TRAVEL,
      formSections.FOREIGN_REVIEW,
    ],
  },
  {
    ...formSections.FINANCIAL,
    subsections: [
      formSections.FINANCIAL_INTRO,
      formSections.FINANCIAL_BANKRUPTCY,
      formSections.FINANCIAL_GAMBLING,
      formSections.FINANCIAL_TAXES,
      formSections.FINANCIAL_CARD,
      formSections.FINANCIAL_CREDIT,
      formSections.FINANCIAL_DELINQUENT,
      formSections.FINANCIAL_NONPAYMENT,
      formSections.FINANCIAL_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [
          formSections.SUBSTANCE_USE_DRUGS_USAGE,
          formSections.SUBSTANCE_USE_DRUGS_PURCHASE,
          formSections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
          formSections.SUBSTANCE_USE_DRUGS_MISUSE,
          formSections.SUBSTANCE_USE_DRUGS_ORDERED,
          formSections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
          formSections.SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE,
          formSections.SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_ALCOHOL,
        subsections: [
          formSections.SUBSTANCE_USE_ALCOHOL_NEGATIVE,
          formSections.SUBSTANCE_USE_ALCOHOL_ORDERED,
          formSections.SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
          formSections.SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL,
        ],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
  {
    ...formSections.LEGAL,
    subsections: [
      formSections.LEGAL_INTRO,
      {
        ...formSections.LEGAL_POLICE,
        subsections: [
          formSections.LEGAL_POLICE_INTRO,
          formSections.LEGAL_POLICE_OFFENSES,
          formSections.LEGAL_POLICE_ADDITIONAL_OFFENSES,
          formSections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
        ],
      },
      {
        ...formSections.LEGAL_INVESTIGATIONS,
        subsections: [
          formSections.LEGAL_INVESTIGATIONS_HISTORY,
          formSections.LEGAL_INVESTIGATIONS_REVOKED,
          formSections.LEGAL_INVESTIGATIONS_DEBARRED,
        ],
      },
      formSections.LEGAL_COURT,
      {
        ...formSections.LEGAL_TECHNOLOGY,
        subsections: [
          formSections.LEGAL_TECHNOLOGY_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_MANIPULATING,
          formSections.LEGAL_TECHNOLOGY_UNLAWFUL,
        ],
      },
      {
        ...formSections.LEGAL_ASSOCIATIONS,
        subsections: [
          formSections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION,
          formSections.LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM,
          formSections.LEGAL_ASSOCIATIONS_ADVOCATING,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE,
          formSections.LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION,
        ],
      },
      formSections.LEGAL_REVIEW,
    ],
  },
  {
    ...formSections.PSYCHOLOGICAL,
    subsections: [
      formSections.PSYCHOLOGICAL_INTRO,
      formSections.PSYCHOLOGICAL_COMPETENCE,
      formSections.PSYCHOLOGICAL_CONSULTATIONS,
      formSections.PSYCHOLOGICAL_HOSPITALIZATIONS,
      formSections.PSYCHOLOGICAL_DIAGNOSES,
      formSections.PSYCHOLOGICAL_CONDITIONS,
      formSections.PSYCHOLOGICAL_REVIEW,
    ],
  },
];

export const SF86 = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_PHYSICAL,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },
  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_FEDERAL,
      formSections.HISTORY_REVIEW,
    ],
  },
  {
    ...formSections.RELATIONSHIPS,
    subsections: [
      formSections.RELATIONSHIPS_INTRO,
      {
        ...formSections.RELATIONSHIPS_STATUS,
        subsections: [
          formSections.RELATIONSHIPS_STATUS_MARITAL,
          formSections.RELATIONSHIPS_STATUS_COHABITANTS,
        ],
      },
      formSections.RELATIONSHIPS_PEOPLE,
      formSections.RELATIONSHIPS_RELATIVES,
      formSections.RELATIONSHIPS_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_MULTIPLE,
      formSections.CITIZENSHIP_PASSPORTS,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_SELECTIVE,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_DISCIPLINARY,
      formSections.MILITARY_FOREIGN,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.FOREIGN,
    subsections: [
      formSections.FOREIGN_INTRO,
      formSections.FOREIGN_CONTACTS,
      {
        ...formSections.FOREIGN_ACTIVITIES,
        subsections: [
          formSections.FOREIGN_ACTIVITIES_DIRECT,
          formSections.FOREIGN_ACTIVITIES_INDIRECT,
          formSections.FOREIGN_ACTIVITIES_REAL_ESTATE,
          formSections.FOREIGN_ACTIVITIES_BENEFITS,
          formSections.FOREIGN_ACTIVITIES_SUPPORT,
        ],
      },
      {
        ...formSections.FOREIGN_BUSINESS,
        subsections: [
          formSections.FOREIGN_BUSINESS_ADVICE,
          formSections.FOREIGN_BUSINESS_FAMILY,
          formSections.FOREIGN_BUSINESS_EMPLOYMENT,
          formSections.FOREIGN_BUSINESS_VENTURES,
          formSections.FOREIGN_BUSINESS_CONFERENCES,
          formSections.FOREIGN_BUSINESS_CONTACT,
          formSections.FOREIGN_BUSINESS_SPONSORSHIP,
          formSections.FOREIGN_BUSINESS_POLITICAL,
          formSections.FOREIGN_BUSINESS_VOTING,
        ],
      },
      formSections.FOREIGN_TRAVEL,
      formSections.FOREIGN_REVIEW,
    ],
  },
  {
    ...formSections.FINANCIAL,
    subsections: [
      formSections.FINANCIAL_INTRO,
      formSections.FINANCIAL_BANKRUPTCY,
      formSections.FINANCIAL_GAMBLING,
      formSections.FINANCIAL_TAXES,
      formSections.FINANCIAL_CARD,
      formSections.FINANCIAL_CREDIT,
      formSections.FINANCIAL_DELINQUENT,
      formSections.FINANCIAL_NONPAYMENT,
      formSections.FINANCIAL_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [
          formSections.SUBSTANCE_USE_DRUGS_USAGE,
          formSections.SUBSTANCE_USE_DRUGS_PURCHASE,
          formSections.SUBSTANCE_USE_DRUGS_CLEARANCE,
          formSections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
          formSections.SUBSTANCE_USE_DRUGS_MISUSE,
          formSections.SUBSTANCE_USE_DRUGS_ORDERED,
          formSections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_ALCOHOL,
        subsections: [
          formSections.SUBSTANCE_USE_ALCOHOL_NEGATIVE,
          formSections.SUBSTANCE_USE_ALCOHOL_ORDERED,
          formSections.SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
          formSections.SUBSTANCE_USE_ALCOHOL_ADDITIONAL,
        ],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
  {
    ...formSections.LEGAL,
    subsections: [
      formSections.LEGAL_INTRO,
      {
        ...formSections.LEGAL_POLICE,
        subsections: [
          formSections.LEGAL_POLICE_INTRO,
          formSections.LEGAL_POLICE_OFFENSES,
          formSections.LEGAL_POLICE_ADDITIONAL_OFFENSES,
          formSections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
        ],
      },
      {
        ...formSections.LEGAL_INVESTIGATIONS,
        subsections: [
          formSections.LEGAL_INVESTIGATIONS_HISTORY,
          formSections.LEGAL_INVESTIGATIONS_REVOKED,
          formSections.LEGAL_INVESTIGATIONS_DEBARRED,
        ],
      },
      formSections.LEGAL_COURT,
      {
        ...formSections.LEGAL_TECHNOLOGY,
        subsections: [
          formSections.LEGAL_TECHNOLOGY_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_MANIPULATING,
          formSections.LEGAL_TECHNOLOGY_UNLAWFUL,
        ],
      },
      {
        ...formSections.LEGAL_ASSOCIATIONS,
        subsections: [
          formSections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION,
          formSections.LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM,
          formSections.LEGAL_ASSOCIATIONS_ADVOCATING,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE,
          formSections.LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW,
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION,
        ],
      },
      formSections.LEGAL_REVIEW,
    ],
  },
  {
    ...formSections.PSYCHOLOGICAL,
    subsections: [
      formSections.PSYCHOLOGICAL_INTRO,
      formSections.PSYCHOLOGICAL_COMPETENCE,
      formSections.PSYCHOLOGICAL_CONSULTATIONS,
      formSections.PSYCHOLOGICAL_HOSPITALIZATIONS,
      formSections.PSYCHOLOGICAL_DIAGNOSES,
      formSections.PSYCHOLOGICAL_CONDITIONS,
      formSections.PSYCHOLOGICAL_REVIEW,
    ],
  },
];

export const PVQ_A = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },
  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_FEDERAL,
      formSections.HISTORY_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_ADDITIONAL,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.RELATIONSHIPS,
    subsections: [
      formSections.RELATIONSHIPS_INTRO,
      formSections.RELATIONSHIPS_PEOPLE,
      formSections.RELATIONSHIPS_REVIEW,
    ],
  },
  {
    ...formSections.FINANCIAL,
    subsections: [
      formSections.FINANCIAL_INTRO,
      formSections.FINANCIAL_FEDERAL_DEBT,
      formSections.FINANCIAL_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [
          formSections.SUBSTANCE_USE_DRUGS_INTRO,
          formSections.SUBSTANCE_USE_DRUGS_USAGE,
          formSections.SUBSTANCE_USE_DRUGS_MISUSE,
          formSections.SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT,
          formSections.SUBSTANCE_USE_DRUGS_PURCHASE,
          formSections.SUBSTANCE_USE_DRUGS_CLEARANCE,
          formSections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
          formSections.SUBSTANCE_USE_DRUGS_ORDERED,
          formSections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_THC,
        subsections: [
          formSections.SUBSTANCE_USE_THC_INTRO,
          formSections.SUBSTANCE_USE_THC_USAGE,
          formSections.SUBSTANCE_USE_THC_PURCHASE,
          formSections.SUBSTANCE_USE_THC_CLEARANCE,
          formSections.SUBSTANCE_USE_THC_PUBLIC_SAFETY,
        ],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
  {
    ...formSections.LEGAL,
    subsections: [
      formSections.LEGAL_INTRO,
      {
        ...formSections.LEGAL_INVESTIGATIONS,
        subsections: [
          formSections.LEGAL_INVESTIGATIONS_INTRO,
          formSections.LEGAL_INVESTIGATIONS_HISTORY,
          formSections.LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES,
          formSections.LEGAL_INVESTIGATIONS_PIV_ISSUES,
          formSections.LEGAL_INVESTIGATIONS_DEBARRED,
          formSections.LEGAL_INVESTIGATIONS_FOREIGN,
        ],
      },
      {
        ...formSections.LEGAL_POLICE,
        subsections: [
          formSections.LEGAL_POLICE_INTRO,
          formSections.LEGAL_POLICE_OFFENSES,
          formSections.LEGAL_POLICE_ADDITIONAL_OFFENSES,
          formSections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
        ],
      },
      {
        ...formSections.LEGAL_TECHNOLOGY,
        subsections: [
          formSections.LEGAL_TECHNOLOGY_INTRO,
          formSections.LEGAL_TECHNOLOGY_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_MANIPULATING,
          formSections.LEGAL_TECHNOLOGY_DENIED,
          formSections.LEGAL_TECHNOLOGY_UNLAWFUL,
        ],
      },
      {
        ...formSections.LEGAL_HANDLING_PROTECTED_INFO,
        subsections: [
          formSections.LEGAL_HANDLING_PROTECTED_INFO_INTRO,
          formSections.LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_NONCOMPLIANCE,
        ],
      },
      {
        ...formSections.LEGAL_ASSOCIATIONS,
        subsections: [
          formSections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT, // PVQ
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY, // PVQ
          formSections.LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_ACTS, // PVQ
          formSections.LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY, // PVQ
        ],
      },
      formSections.LEGAL_REVIEW,
    ],
  },
];

export const PVQ_A_B = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },
  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_FEDERAL,
      formSections.HISTORY_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_ADDITIONAL,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.RELATIONSHIPS,
    subsections: [
      formSections.RELATIONSHIPS_INTRO,
      formSections.RELATIONSHIPS_STATUS_MARITAL_PVQ,
      formSections.RELATIONSHIPS_RELATIVES,
      formSections.RELATIONSHIPS_PEOPLE,
      formSections.RELATIONSHIPS_REVIEW,
    ],
  },
  {
    ...formSections.FOREIGN,
    subsections: [
      formSections.FOREIGN_INTRO,
      formSections.FOREIGN_TRAVEL,
      formSections.FOREIGN_REVIEW,
    ],
  },
  {
    ...formSections.FINANCIAL,
    subsections: [
      formSections.FINANCIAL_INTRO,
      formSections.FINANCIAL_BANKRUPTCY,
      formSections.FINANCIAL_ALIMONY,
      formSections.FINANCIAL_CHILD_SUPPORT,
      formSections.FINANCIAL_CIVIL_JUDGEMENT,
      formSections.FINANCIAL_LIEN,
      formSections.FINANCIAL_FORECLOSURE,
      formSections.FINANCIAL_REPOSSESSION,
      formSections.FINANCIAL_EVICTION,
      formSections.FINANCIAL_ASSET_SEIZED,
      formSections.FINANCIAL_NONPAYMENT_NONFEDERAL,
      formSections.FINANCIAL_CARD,
      formSections.FINANCIAL_CREDIT,
      formSections.FINANCIAL_DELINQUENT,
      formSections.FINANCIAL_FEDERAL_DEBT,
      formSections.FINANCIAL_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [
          formSections.SUBSTANCE_USE_DRUGS_INTRO,
          formSections.SUBSTANCE_USE_DRUGS_USAGE,
          formSections.SUBSTANCE_USE_DRUGS_MISUSE,
          formSections.SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT,
          formSections.SUBSTANCE_USE_DRUGS_PURCHASE,
          formSections.SUBSTANCE_USE_DRUGS_CLEARANCE,
          formSections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
          formSections.SUBSTANCE_USE_DRUGS_ORDERED,
          formSections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_THC,
        subsections: [
          formSections.SUBSTANCE_USE_THC_INTRO,
          formSections.SUBSTANCE_USE_THC_USAGE,
          formSections.SUBSTANCE_USE_THC_PURCHASE,
          formSections.SUBSTANCE_USE_THC_CLEARANCE,
          formSections.SUBSTANCE_USE_THC_PUBLIC_SAFETY,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_ALCOHOL,
        subsections: [
          formSections.SUBSTANCE_USE_ALCOHOL_INTRO,
          formSections.SUBSTANCE_USE_ALCOHOL_NEGATIVE,
          formSections.SUBSTANCE_USE_ALCOHOL_ORDERED,
          formSections.SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
        ],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
  {
    ...formSections.LEGAL,
    subsections: [
      formSections.LEGAL_INTRO,
      {
        ...formSections.LEGAL_INVESTIGATIONS,
        subsections: [
          formSections.LEGAL_INVESTIGATIONS_INTRO,
          formSections.LEGAL_INVESTIGATIONS_HISTORY,
          formSections.LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES,
          formSections.LEGAL_INVESTIGATIONS_PIV_ISSUES,
          formSections.LEGAL_INVESTIGATIONS_DEBARRED,
          formSections.LEGAL_INVESTIGATIONS_FOREIGN
        ],
      },
      {
        ...formSections.LEGAL_POLICE,
        subsections: [
          formSections.LEGAL_POLICE_INTRO,
          formSections.LEGAL_POLICE_OFFENSES,
          formSections.LEGAL_POLICE_ADDITIONAL_OFFENSES,
          formSections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
        ],
      },
      formSections.LEGAL_COURT,
      {
        ...formSections.LEGAL_HANDLING_PROTECTED_INFO,
        subsections: [
          formSections.LEGAL_HANDLING_PROTECTED_INFO_INTRO,
          formSections.LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_NONCOMPLIANCE,
        ],
      },
      {
        ...formSections.LEGAL_ASSOCIATIONS,
        subsections: [
          formSections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT, // PVQ
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY, // PVQ
          formSections.LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_ACTS, // PVQ
          formSections.LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY, // PVQ
        ]
      },
      {
        ...formSections.LEGAL_TECHNOLOGY,
        subsections: [
          formSections.LEGAL_TECHNOLOGY_INTRO,
          formSections.LEGAL_TECHNOLOGY_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_MANIPULATING,
          formSections.LEGAL_TECHNOLOGY_DENIED,
          formSections.LEGAL_TECHNOLOGY_UNLAWFUL,
        ],
      },
      formSections.LEGAL_REVIEW,
    ],
  },
];

export const PVQ_A_B_C = [
  {
    ...formSections.IDENTIFICATION,
    subsections: [
      formSections.IDENTIFICATION_INTRO,
      formSections.IDENTIFICATION_NAME,
      formSections.IDENTIFICATION_BIRTH_DATE,
      formSections.IDENTIFICATION_BIRTH_PLACE,
      formSections.IDENTIFICATION_SSN,
      formSections.IDENTIFICATION_OTHER_NAMES,
      formSections.IDENTIFICATION_CONTACTS,
      formSections.IDENTIFICATION_REVIEW,
    ],
  },
  {
    ...formSections.CITIZENSHIP,
    subsections: [
      formSections.CITIZENSHIP_INTRO,
      formSections.CITIZENSHIP_US_PASSPORT,
      formSections.CITIZENSHIP_STATUS,
      formSections.CITIZENSHIP_ADDITIONAL,
      formSections.CITIZENSHIP_REVIEW,
    ],
  },
  {
    ...formSections.HISTORY,
    subsections: [
      formSections.HISTORY_INTRO,
      formSections.HISTORY_RESIDENCE,
      formSections.HISTORY_EDUCATION,
      formSections.HISTORY_EMPLOYMENT,
      formSections.HISTORY_FEDERAL,
      formSections.HISTORY_REVIEW,
    ],
  },

  {
    ...formSections.MILITARY,
    subsections: [
      formSections.MILITARY_INTRO,
      formSections.MILITARY_HISTORY,
      formSections.MILITARY_REVIEW,
    ],
  },
  {
    ...formSections.RELATIONSHIPS,
    subsections: [
      formSections.RELATIONSHIPS_INTRO,
      formSections.RELATIONSHIPS_STATUS_MARITAL_PVQ,
      formSections.RELATIONSHIPS_PEOPLE,
      formSections.RELATIONSHIPS_RELATIVES,
      formSections.RELATIONSHIPS_REVIEW,
    ],
  },
  {
    ...formSections.FINANCIAL,
    subsections: [
      formSections.FINANCIAL_INTRO,
      formSections.FINANCIAL_BANKRUPTCY,
      formSections.FINANCIAL_ALIMONY,
      formSections.FINANCIAL_CHILD_SUPPORT,
      formSections.FINANCIAL_CIVIL_JUDGEMENT,
      formSections.FINANCIAL_LIEN,
      formSections.FINANCIAL_FORECLOSURE,
      formSections.FINANCIAL_REPOSSESSION,
      formSections.FINANCIAL_EVICTION,
      formSections.FINANCIAL_ASSET_SEIZED,
      formSections.FINANCIAL_NONPAYMENT_NONFEDERAL,
      formSections.FINANCIAL_CARD,
      formSections.FINANCIAL_CREDIT,
      formSections.FINANCIAL_DELINQUENT,
      formSections.FINANCIAL_FEDERAL_DEBT,
      formSections.FINANCIAL_REVIEW,
    ],
  },
  {
    ...formSections.SUBSTANCE_USE,
    subsections: [
      formSections.SUBSTANCE_USE_INTRO,
      {
        ...formSections.SUBSTANCE_USE_DRUGS,
        subsections: [
          formSections.SUBSTANCE_USE_DRUGS_INTRO,
          formSections.SUBSTANCE_USE_DRUGS_USAGE,
          formSections.SUBSTANCE_USE_DRUGS_MISUSE,
          formSections.SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT,
          formSections.SUBSTANCE_USE_DRUGS_PURCHASE,
          formSections.SUBSTANCE_USE_DRUGS_CLEARANCE,
          formSections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
          formSections.SUBSTANCE_USE_DRUGS_ORDERED,
          formSections.SUBSTANCE_USE_DRUGS_VOLUNTARY,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_THC,
        subsections: [
          formSections.SUBSTANCE_USE_THC_INTRO,
          formSections.SUBSTANCE_USE_THC_USAGE,
          formSections.SUBSTANCE_USE_THC_PURCHASE,
          formSections.SUBSTANCE_USE_THC_CLEARANCE,
          formSections.SUBSTANCE_USE_THC_PUBLIC_SAFETY,
        ],
      },
      {
        ...formSections.SUBSTANCE_USE_ALCOHOL,
        subsections: [
          formSections.SUBSTANCE_USE_ALCOHOL_INTRO,
          formSections.SUBSTANCE_USE_ALCOHOL_NEGATIVE,
          formSections.SUBSTANCE_USE_ALCOHOL_ORDERED,
          formSections.SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
        ],
      },
      formSections.SUBSTANCE_USE_REVIEW,
    ],
  },
  {
    ...formSections.FOREIGN,
    subsections: [
      formSections.FOREIGN_INTRO,
      formSections.FOREIGN_TRAVEL,
      formSections.FOREIGN_CONTACTS,
      {
        ...formSections.FOREIGN_BUSINESS,
        subsections: [
          formSections.FOREIGN_BUSINESS_INTRO,
          formSections.FOREIGN_BUSINESS_ADVICE,
          formSections.FOREIGN_BUSINESS_FAMILY,
          formSections.FOREIGN_BUSINESS_EMPLOYMENT,
          formSections.FOREIGN_BUSINESS_VENTURES,
          formSections.FOREIGN_BUSINESS_CONTACT,
          formSections.FOREIGN_BUSINESS_SPONSORSHIP,
          formSections.FOREIGN_BUSINESS_POLITICAL,
          formSections.FOREIGN_BUSINESS_VOTING,
        ],
      },
      {
        ...formSections.FOREIGN_ACTIVITIES,
        subsections: [
          formSections.FOREIGN_ACTIVITIES_INTRO,
          formSections.FOREIGN_ACTIVITIES_DIRECT,
          formSections.FOREIGN_ACTIVITIES_INDIRECT,
          formSections.FOREIGN_ACTIVITIES_FUTURE,
          formSections.FOREIGN_ACTIVITIES_CURRENT,
          formSections.FOREIGN_ACTIVITIES_ONGOINGSUPPORT,
          formSections.FOREIGN_ACTIVITIES_SUPPORT,
        ],
      },

      formSections.FOREIGN_REVIEW,
    ],
  },
  {

    ...formSections.LEGAL,
    subsections: [
      formSections.LEGAL_INTRO,
      {
        ...formSections.LEGAL_INVESTIGATIONS,
        subsections: [
          formSections.LEGAL_INVESTIGATIONS_INTRO,
          formSections.LEGAL_INVESTIGATIONS_HISTORY,
          formSections.LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES,
          formSections.LEGAL_INVESTIGATIONS_PIV_ISSUES,
          formSections.LEGAL_INVESTIGATIONS_DEBARRED,
          formSections.LEGAL_INVESTIGATIONS_FOREIGN
        ],
      },
      {
        ...formSections.LEGAL_POLICE,
        subsections: [
          formSections.LEGAL_POLICE_INTRO,
          formSections.LEGAL_POLICE_OFFENSES,
          formSections.LEGAL_POLICE_ADDITIONAL_OFFENSES,
          formSections.LEGAL_POLICE_DOMESTIC_VIOLENCE,
        ],
      },
      formSections.LEGAL_COURT,
      {
        ...formSections.LEGAL_TECHNOLOGY,
        subsections: [
          formSections.LEGAL_TECHNOLOGY_INTRO,
          formSections.LEGAL_TECHNOLOGY_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_MANIPULATING,
          formSections.LEGAL_TECHNOLOGY_DENIED,
          formSections.LEGAL_TECHNOLOGY_UNLAWFUL,
        ],
      },
      {
        ...formSections.LEGAL_HANDLING_PROTECTED_INFO,
        subsections: [
          formSections.LEGAL_HANDLING_PROTECTED_INFO_INTRO,
          formSections.LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED,
          formSections.LEGAL_TECHNOLOGY_NONCOMPLIANCE,
        ],
      },
      formSections.LEGAL_CRIMINAL_CONVICTIONS,
      {
        ...formSections.LEGAL_ASSOCIATIONS,
        subsections: [
          formSections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT, // PVQ
          formSections.LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY, // PVQ
          formSections.LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION, // PVQ
          formSections.LEGAL_ASSOCIATIONS_VIOLENT_ACTS, // PVQ
          formSections.LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION, // PVQ
          formSections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY, // PVQ
        ],
      },
      formSections.LEGAL_REVIEW,
    ],
  },
  {
    ...formSections.PSYCHOLOGICAL,
    subsections: [
      formSections.PSYCHOLOGICAL_INTRO,
      formSections.PSYCHOLOGICAL_COMPETENCE,
      formSections.PSYCHOLOGICAL_CONSULTATIONS,
      formSections.PSYCHOLOGICAL_HOSPITALIZATIONS,
      formSections.PSYCHOLOGICAL_DIAGNOSES,
      formSections.PSYCHOLOGICAL_CONDITIONS,
      formSections.PSYCHOLOGICAL_REVIEW,
    ],
  },
];

export const PVQ_A_B_D = [
  ...PVQ_A_B,
  {
    ...formSections.PSYCHOLOGICAL,
    subsections: [
      formSections.PSYCHOLOGICAL_INTRO,
      formSections.PSYCHOLOGICAL_COMPETENCE,
      formSections.PSYCHOLOGICAL_CONSULTATIONS,
      formSections.PSYCHOLOGICAL_HOSPITALIZATIONS,
      formSections.PSYCHOLOGICAL_DIAGNOSES,
      formSections.PSYCHOLOGICAL_CONDITIONS,
      formSections.PSYCHOLOGICAL_REVIEW,
    ],
  },

];

// Export this separately so it's not included when looping through actual form sections
export const reviewSections = {
  ...formSections.REVIEW_AND_SUBMIT,
  subsections: [
    formSections.REVIEW_AND_SUBMIT_COMMENTS,
    formSections.REVIEW_AND_SUBMIT_REVIEW,
    formSections.REVIEW_AND_SUBMIT_SUBMIT,
    formSections.REVIEW_AND_SUBMIT_PRINT,
  ],
};

// Export this separately so it's not included when looping through actual form sections
export const pvqReviewSections = {
  ...formSections.REVIEW_AND_SUBMIT,
  subsections: [
    formSections.REVIEW_AND_SUBMIT_REVIEW,
    formSections.REVIEW_AND_SUBMIT_SUBMIT,
    formSections.REVIEW_AND_SUBMIT_PRINT,
  ],
};
/**
 *
 * @returns []any
 */
export const reduceSubsections = (sections, parentPath, breadcrumbs = [], parentStore) => sections.reduce((accumulator, section) => {
  if (section.subsections && section.subsections.length) {
    const builtPath = parentPath ? `${parentPath}/${section.path}` : section.path;

    const store = parentStore || section.store;

    /* eslint no-param-reassign: 0 */
    accumulator = accumulator.concat(
      reduceSubsections(section.subsections, builtPath, [...breadcrumbs, section.label], store)
    );
  } else {
    accumulator.push({
      ...section,
      fullPath: `/form/${parentPath}/${section.path}`,
      breadcrumbs: [...breadcrumbs, section.label],
      parentStore,
    });
  }

  return accumulator;
}, []);

export const FLAT_SF852013 = reduceSubsections(SF852013);
export const FLAT_SF85 = reduceSubsections(SF85);
export const FLAT_SF85P = reduceSubsections(SF85P);
export const FLAT_SF86 = reduceSubsections(SF86);
export const FLAT_SF85PS = reduceSubsections(SF85PS);
export const FLAT_PVQ_A = reduceSubsections(PVQ_A);
export const FLAT_PVQ_A_B = reduceSubsections(PVQ_A_B);
export const FLAT_PVQ_A_B_C = reduceSubsections(PVQ_A_B_C);
export const FLAT_PVQ_A_B_D = reduceSubsections(PVQ_A_B_D);

export const formTypes = {
  SF852013,
  SF85,
  SF85P,
  'SF85P+85P-S': SF85PS,
  SF85PS,
  SF86,
  'PVQ-A': PVQ_A,
  PVQ_A,
  'PVQ-A-B': PVQ_A_B,
  PVQ_A_B,
  'PVQ-A-B-C': PVQ_A_B_C,
  PVQ_A_B_C,
  'PVQ-A-B-D': PVQ_A_B_D,
  PVQ_A_B_D,
  reviewSections,
  pvqReviewSections,
  reduceSubsections,
  FLAT_SF85,
  FLAT_SF852013,
  FLAT_SF85P,
  'FLAT_SF85P+85P-S': FLAT_SF85PS,
  FLAT_SF85PS,
  FLAT_SF86,
  'FLAT_PVQ-A': FLAT_PVQ_A,
  FLAT_PVQ_A,
  'FLAT_PVQ-A-B': FLAT_PVQ_A_B,
  FLAT_PVQ_A_B,
  'FLAT_PVQ-A-B-C': FLAT_PVQ_A_B_C,
  FLAT_PVQ_A_B_C,
  'FLAT_PVQ-A-B-D': FLAT_PVQ_A_B_D,
  FLAT_PVQ_A_B_D
};
